export const GET_NOTIFIED_STEP = {
  AUTHENTICATION: 'authentication',
  SUBMIT: 'submit',
}
